export default {
  inserted(el, { value: ms }) {
    setTimeout(() => el.focus(), ms || 1);
  },
};
